import { Capacitor } from '@capacitor/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

function isAndroidNative(): boolean {
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
}

function toErrorMessage(error: unknown): string {
    if (error instanceof Error) {
        return error.message || error.name || 'Unknown error';
    }

    if (typeof error === 'string') {
        return error;
    }

    try {
        return JSON.stringify(error);
    } catch {
        return String(error);
    }
}

export async function recordCrashlyticsException(error: unknown): Promise<void> {
    if (!isAndroidNative()) {
        return;
    }

    const message = toErrorMessage(error);

    try {
        await FirebaseCrashlytics.recordException({
            message,
        });
    } catch (crashlyticsError) {
        console.error('Failed to record Crashlytics exception', crashlyticsError);
    }
}
